module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/flecha-grey.96f0a0fa.svg";